const myself = [
    {
        'q': 'Jag motionerar regelbundet och tillräckligt',
        'a': 0
    },
    {
        'q': 'Jag har en bra relation med min partner',
        'a': 0,
    },
    {
        'q': 'Jag äter regelbundet och näringsrikt',
        'a': 0,
    },
    {
        'q': 'Jag vilar och återhämtar mig regelbundet',
        'a': 0,
    },
    {
        'q': 'Jag känner att min ork och energi räcker till',
        'a': 0,
    },
    {
        'q': 'Jag har fritidsaktiviteter jag gillar',
        'a': 0,
    },
    {
        'q': 'Jag vistas regelbundet i naturen',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med mitt sociala liv',
        'a': 0,
    },
    {
        'q': 'Min vardag känns meningsfull',
        'a': 0,
    },
    {
        'q': 'Jag bidrar till andra runtomkring mig',
        'a': 0,
    },
    {
        'q': 'Jag kan påverka det som är viktigt för mig',
        'a': 0,
    },
    {
        'q': 'Jag ber om hjälp när jag behöver det',
        'a': 0,
    },
    {
        'q': 'Jag har någon att prata om svårigheter med',
        'a': 0,
    },
    {
        'q': 'Jag har en fungerande ekonomisk situation',
        'a': 0,
    },
    {
        'q': 'Jag har tid för reflektion och planering',
        'a': 0,
    },
    {
        'q': 'Jag är nöjd med helheten i min vardag',
        'a': 0,
    },
    {
        'q': 'Jag trivs med hur jag använder sociala medier',
        'a': 0,
    },
];

export default myself;